import {
  RECOMMEND_BANNER_SUCCESS,
  RECOMMEND_WEEK_HOTS_SUCCESS,
  RECOMMEND_RECOMMEND_SUCCESS,
  RECOMMEND_GROUP_SUCCESS,
  GUESS_LIKES_SUCCESS,
  GET_SOFTINFOS_SUCCESS,
  RECO_TOP_CONTENTS_SUCCESS,
  RECOWORK_TOP_CONTENTS_SUCCESS,
  RECOOTHER_TOP_CONTENTS_SUCCESS,
  RECO_RECOMMEND_CONTENTS_SUCCESS,
  RECOWORK_RECOMMEND_CONTENTS_SUCCESS,
  RECOOTHER_RECOMMEND_CONTENTS_SUCCESS,
  RECOMMEND_OTHER_TOP_SUCCESS,
  GET_SOFTINFOS_BY_V_SUCCESS,
} from '../constants/recommend';

const initState = {
  recoBanner: {},
  recoRecommend: {},
  recoWorkBanner: {},
  recoWorkRecommend: {},
  recoOtherBanner: {},
  recoOtherRecommend: {},
  recoOtherTop: {},
  banners: null,
  weekHots: {},
  recommends: {},
  groups: {},
  commGroups: null,
  guessLike: {},
  softInfos: {},
  softInfosVersion: {},
};

const recommend = (state = initState, action = {}) => {
  switch (action.type) {
    case RECO_TOP_CONTENTS_SUCCESS:
      return { ...state, recoBanner: action.payload };
    case RECO_RECOMMEND_CONTENTS_SUCCESS:
      return { ...state, recoRecommend: action.payload };
    case RECOWORK_TOP_CONTENTS_SUCCESS:
      return { ...state, recoWorkBanner: action.payload };
    case RECOWORK_RECOMMEND_CONTENTS_SUCCESS:
      return { ...state, recoWorkRecommend: action.payload };
    case RECOOTHER_TOP_CONTENTS_SUCCESS:
      return { ...state, recoOtherBanner: action.payload };
    case RECOOTHER_RECOMMEND_CONTENTS_SUCCESS:
      return { ...state, recoOtherRecommend: action.payload };
    case RECOMMEND_BANNER_SUCCESS:
      return { ...state, banners: action.payload };
    case RECOMMEND_WEEK_HOTS_SUCCESS:
      return { ...state, weekHots: action.payload };
    case RECOMMEND_RECOMMEND_SUCCESS:
      return { ...state, recommends: action.payload };
    case RECOMMEND_GROUP_SUCCESS:
      // commGroups 特殊处理
      if (action.payload && action.payload && action.payload.pageType === 'upgrade') {
        return { ...state, commGroups: action.payload };
      }
      return { ...state, groups: action.payload };
    case GUESS_LIKES_SUCCESS:
      return { ...state, guessLike: action.payload };
    case GET_SOFTINFOS_SUCCESS:
      return { ...state, softInfos: action.payload };
    case GET_SOFTINFOS_BY_V_SUCCESS:
      return { ...state, softInfosVersion: action.payload };
    case RECOMMEND_OTHER_TOP_SUCCESS:
      return { ...state, recoOtherTop: action.payload };
    default:
      return state;
  }
};

export default recommend;
